import { render, staticRenderFns } from "./player-item.vue?vue&type=template&id=17461a50&scoped=true"
import script from "./player-item.vue?vue&type=script&lang=js"
export * from "./player-item.vue?vue&type=script&lang=js"
import style0 from "./player-item.vue?vue&type=style&index=0&id=17461a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17461a50",
  null
  
)

export default component.exports